/* Hero — Chapter II "The Craft" cover-scale headline. */

import {
  ChapterEyebrow, DisplayHeadline, GoldRule, GoldFoilButton, HairlineButton,
  RotatedCaption, FilmGrain,
} from "@/components/editorial";
import { EDITORIAL_ASSETS } from "@/lib/editorialAssets";

export default function HeroSection() {
  const hero = EDITORIAL_ASSETS.hero_lumetier_main;
  return (
    <section className="relative min-h-[92vh] flex items-center overflow-hidden bg-[color:var(--charcoal)]">
      {/* Full-bleed editorial cover — composition leaves negative space on
          the left for the headline to sit over. Renders as <img> (not
          background-image) so we get explicit dimensions + lazy-load
          semantics. `fetchpriority=high` because this is the page LCP. */}
      <img
        src={hero.src}
        alt={hero.alt}
        width={hero.w}
        height={hero.h}
        loading="eager"
        fetchpriority="high"
        className="absolute inset-0 w-full h-full object-cover object-right opacity-90 pointer-events-none select-none"
        style={{ transform: "translateZ(0)" }}
      />
      {/* Charcoal scrim on the left so the cream headline reads clearly */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(90deg, rgba(14,13,12,0.92) 0%, rgba(14,13,12,0.72) 38%, rgba(14,13,12,0.28) 70%, rgba(14,13,12,0.12) 100%)",
        }}
      />
      <FilmGrain opacity={0.06} tone="cool" />
      {/* Soft gold radial glow off-center, kept subtle so it doesn't fight
          the photograph */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute -top-40 right-1/4 w-[820px] h-[620px]"
          style={{ background: "radial-gradient(ellipse, rgba(212,184,114,0.10) 0%, transparent 65%)" }}
        />
      </div>
      <div className="hidden lg:block absolute left-4 bottom-32 z-20">
        <RotatedCaption tone="gold">CHAPTER II — THE CRAFT</RotatedCaption>
      </div>
      <div className="relative z-10 max-w-[1480px] w-full mx-auto px-6 lg:px-12 pt-20 lg:pt-28 pb-16">
        <GoldRule width="2rem" />
        <div className="mt-3">
          <ChapterEyebrow chapter="II" label="The Craft" />
        </div>
        <DisplayHeadline size="cover" tone="charcoal" className="mt-8 max-w-[16ch]" data-reveal="rise">
          You started shooting because you love the craft. Not the <em>admin</em>.
        </DisplayHeadline>
        <p className="ed-body-lg mt-8 max-w-xl text-[color:var(--cream)]/70 leading-relaxed" data-reveal="rise">
          Lumetier is the studio platform for working photographers — bookings, contracts, galleries, payments, reviews — in one quiet room. Built by a photographer who got tired of using five different tools.
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-4" data-reveal="rise">
          <GoldFoilButton href="#apply">Get an invite</GoldFoilButton>
          <HairlineButton href="#customize" tone="dark">Try the gallery</HairlineButton>
        </div>
        <div className="mt-14">
          <a
            href="https://allure-image.com"
            target="_blank"
            rel="noopener noreferrer"
            className="ed-eyebrow text-[color:var(--cream)]/45 hover:text-[color:var(--gold-foil)] transition-colors"
          >
            Made by <span className="text-[color:var(--cream)]/80">Allure Image</span> · a working photography studio
          </a>
        </div>
      </div>
    </section>
  );
}
